import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
}

const setMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

export const useSeo = ({ title, description, keywords }: SeoOptions) => {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
  }, [title, description, keywords]);
};